var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamationMarkOffblack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.4999 1.8999C4.4199 1.8999 1.8999 4.4199 1.8999 7.4999C1.8999 10.5799 4.4199 13.0999 7.4999 13.0999C10.5799 13.0999 13.0999 10.5799 13.0999 7.4999C13.0999 4.4199 10.5799 1.8999 7.4999 1.8999Z",
    fill: "#505363"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.08002 8.6199H7.99002C8.20002 8.6199 8.34002 8.4799 8.34002 8.2699L8.48002 3.9999C8.48002 3.7899 8.34002 3.6499 8.13002 3.6499H6.87002C6.66002 3.6499 6.52002 3.7899 6.52002 3.9999L6.66002 8.2699C6.73002 8.4799 6.87002 8.6199 7.08002 8.6199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50002 9.3899C6.94002 9.3899 6.52002 9.8099 6.52002 10.3699C6.52002 10.9299 6.94002 11.3499 7.50002 11.3499C7.99002 11.3499 8.48002 10.9299 8.48002 10.3699C8.48002 9.8099 7.99002 9.3899 7.50002 9.3899Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkOffblack);
export default __webpack_public_path__ + "static/media/exclamation-mark_offblack.82fc515de9a9ef16bbfed26f161eb2d8.svg";
export { ForwardRef as ReactComponent };